import { useCallback } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { getTranslationFn } from 'src/utils/get-translation-fn';

export const useLocale = () => {
  const { lang, locale } = useAppContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(getTranslationFn(lang, locale), [lang, locale]);
};
